import React from 'react';
import PropTypes from 'prop-types';

const ViewProfile = ({ fillColor = '#000', ...props }) => {
  return (
/*     <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00063 1.575C7.34323 1.575 6.00063 2.91729 6.00063 4.57265C6.00063 6.22802 7.34323 7.57031 9.00063 7.57031C10.658 7.57031 12.0006 6.22802 12.0006 4.57265C12.0006 2.91729 10.658 1.575 9.00063 1.575ZM4.80063 4.57265C4.80063 2.25381 6.68123 0.375 9.00063 0.375C11.32 0.375 13.2006 2.25381 13.2006 4.57265C13.2006 6.8915 11.32 8.77031 9.00063 8.77031C6.68123 8.77031 4.80063 6.8915 4.80063 4.57265ZM6.00078 11.618C4.34379 11.618 3.00078 12.9606 3.00078 14.6174V16.4141H15.0006V14.6174C15.0006 12.9606 13.6576 11.618 12.0006 11.618H6.00078ZM1.80078 14.6174C1.80078 12.2976 3.68132 10.418 6.00078 10.418H12.0006C14.3201 10.418 16.2006 12.2976 16.2006 14.6174V17.6141H1.80078V14.6174Z"
        fill={fillColor}
      />
    </svg> */

/*     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 2000 2000"><g fill="#f3ba2f"><path d="M611.59 840.42l388.4-388.39 388.6 388.59 226-226L999.99 0 385.6 614.42l225.99 226M.006 999.969l226.007-226.007 225.992 225.993L226 1225.96zM611.59 1159.58l388.4 388.39 388.59-388.58 226.12 225.88-.11.12L999.99 2000l-614.41-614.4-.32-.32 226.33-225.7M1548.013 1000.093l226.007-226.006 225.992 225.992-226.006 226.007z"/><path d="M1229.22 999.88h.1L999.99 770.55 830.51 940.03h-.01l-19.47 19.48-40.16 40.17-.32.31.32.33 229.12 229.13 229.33-229.33.11-.13-.21-.11"/></g></svg>
 */  
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 121.378 121.333">
  <g id="bscscan-logo-circle" transform="translate(-219.378 -213.334)">
    <path id="Path_1" data-name="Path 1" d="M244.6,271.1a5.144,5.144,0,0,1,5.168-5.143l8.568.028a5.151,5.151,0,0,1,5.151,5.151v32.4c.965-.286,2.2-.591,3.559-.911a4.292,4.292,0,0,0,3.309-4.177V258.261a5.152,5.152,0,0,1,5.151-5.152H284.1a5.152,5.152,0,0,1,5.151,5.152v37.3s2.15-.87,4.243-1.754a4.3,4.3,0,0,0,2.625-3.957V245.383a5.151,5.151,0,0,1,5.15-5.151h8.585A5.151,5.151,0,0,1,315,245.383V282c7.443-5.394,14.986-11.882,20.972-19.683a8.646,8.646,0,0,0,1.316-8.072,60.636,60.636,0,1,0-109.855,50.108,7.668,7.668,0,0,0,7.316,3.79c1.624-.143,3.646-.345,6.05-.627a4.29,4.29,0,0,0,3.805-4.258V271.1" fill="#12161c"/>
    <path id="Path_2" data-name="Path 2" d="M244.417,323.061A60.656,60.656,0,0,0,340.756,274c0-1.4-.065-2.778-.158-4.152-22.163,33.055-63.085,48.508-96.181,53.213" fill="#f0b90b"/>
  </g>
</svg>

);
};

ViewProfile.propTypes = {
  fillColor: PropTypes.string,
};

export default ViewProfile;
